import moment from 'moment'
import { periodoPadraoVisaoGeral } from '@modules/comissoes/utils/periodoPadrao'

export const buildInitialState = () => ({
  dataReferencia: null,
  ultimoProfissionalFiltrado: null,
  selectedFilters: {
    data_inicio: moment().subtract(6, 'month').format('DD/MM/YYYY'),
    data_final: moment().format('DD/MM/YYYY'),
    equipe: [],
    origem: [],
    profissional: [],
    filial: [],
    categoria: [],
    tags: [],
    produto: [],
  },
  advisorCommissions: {
    loading: false,
    lastUpdate: null,
    visibleValues: false,
    summary: {},
    data: [],
  },
  rules: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  tax: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  payments: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  spreadsSheet: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  brokers: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  sheetTypes: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  sheetModels: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  lists: {
    loading: false,
    lastUpdate: null,
    data: [],
    audit: {},
  },
  fechamentos: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  filterOptions: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  minimoGarantido: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  manualAdjustments: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  fieldChange: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  filterOptionsRules: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  paymentsGroups: {
    loading: false,
    lastUpdate: null,
    data: [],
    // Competência que a lista em `data` representa. O cache desta fatia é POR
    // COMPETÊNCIA: sem este campo, `lastUpdate` fresco de um mês servia a lista
    // dele para outro. Ver `comissoes/CLAUDE.md` §8.
    refDate: null,
  },
  paymentGroupNames: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  aprovacaoProfissional: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  summaryOverview: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  revenueHistory: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  commissions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  commissionsDetails: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  revenueOverview: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  revenueOverviewDetails: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  generalData: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Tabela da aba ROA. `data` guarda o envelope inteiro (metadata/total/itens) porque
  // o cabeçalho da tela precisa da competência e da origem da receita junto dos dados.
  roaData: {
    loading: false,
    lastUpdate: null,
    data: { metadata: null, total: null, itens: [] },
  },
  roaCompetencias: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  clientAnalysis: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  resultsByAdvisor: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  resultsByCategories: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  comentarios: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  exportPayments: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dadosIndicadores: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dadosProfissionais: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dadosCategorias: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  referenceBase: {
    loading: false,
    lastUpdate: null,
    data: {
      data: [],
      colunas_variaveis: [],
    },
  },
  baseClientes: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  localFilters: {
    loading: false,
    lastUpdate: null,
    data: {
      // Janela padrão em máscara de fim de mês — a view-overview copia esses
      // valores para selectedFilters no created() (ver periodoPadrao.js).
      ...periodoPadraoVisaoGeral(),
      equipe: [],
      origem: [],
      profissional: [],
      filial: [],
      categoria: [],
      tags: [],
      produto: [],
      cliente: [],
      historico_receita_agrupar_por: 'time',
    },
  },
  gatilhosPerformance: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  gatilhosIndicadores: {
      loading: false,
      lastUpdate: null,
      data: [],
      resultados: [],
  },
  // {{NEXT}}
})

export default buildInitialState()
